import { createRouter, createWebHistory } from "vue-router";

import TheMainLayout from "@/layouts/TheMainLayout";
import TheLegalLayout from "@/layouts/TheLegalLayout";
import TheImpressumView from "@/views/TheImpressumView";
import TheDatenschutzView from "@/views/TheDatenschutzView";

const routes = [

  {
    path: "/",
    name: "home",
    component: TheMainLayout,
    meta: { title: "WIESNERD – IT, Automation und Webentwicklung" },
  },

  {
    path: "/impressum",
    name: "impressum",
    component: TheLegalLayout,
    children: [
      {
        path: "",
        component: TheImpressumView,
      },
    ],
    meta: { title: "Impressum – WIESNERD", noindex: true },
  },

  {
    path: "/datenschutz",
    name: "datenschutz",
    component: TheLegalLayout,
    children: [
      {
        path: "",
        component: TheDatenschutzView,
      },
    ],
    meta: { title: "Datenschutz – WIESNERD", noindex: true },
  },

];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

router.beforeEach((to, from, next) => {

  document.title = to.meta.title || "WIESNERD";

  let robotsTag = document.querySelector('meta[name="robots"]');
  if (!robotsTag) {
    robotsTag = document.createElement("meta");
    robotsTag.setAttribute("name", "robots");
    document.head.appendChild(robotsTag);
  }
  robotsTag.setAttribute("content", to.meta.noindex ? "noindex, follow" : "index, follow");

  next();

});

export default router;
